<template>
    <b-form-input
        v-bind="$attrs"
        :value="unformatted"
        :formatter="formatter"
        :lazy-formatter="lazy"
        :required="required"
        @keydown="onKeyDown"
        @blur="blur"
        @input="input"
    />
</template>

<script>
import numeral from "numeral";
import _ from "lodash";

export default {
    inheritAttrs: false,

    props: {
        value: {
            required: false,
            type: [Number, String],
            default: "",
        },
        allowDecimal: {
            required: false,
            type: Boolean,
            default: false,
        },
        lazy: {
            required: false,
            type: Boolean,
            default: false,
        },
        required: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    data() {
        return {
            unformatted: null,
            formatted: "",
        };
    },

    methods: {
        formatter(value) {
            return this.addFormat(value);
        },
        onKeyDown(e) {
            if (!this.isValid(e.key)) {
                e.preventDefault();
            }
        },
        isValid(key) {
            console.log("key", key);
            return (
                /^\d+/g.test(key) ||
                (this.allowDecimal && key === ".") ||
                key === "Backspace" ||
                key === "Enter" ||
                key === "ArrowLeft" ||
                key === "ArrowRight" ||
                key === "Tab"
            );
        },
        addFormat(val) {
            const numbers = _.split(val, ".");

            let formatted = numeral(numbers[0]).format("0,0");

            if (numbers.length > 1 && this.allowDecimal) {
                formatted += "." + numbers[1].substr(0, 2);
            }

            return formatted;
        },
        removeFormat(val) {
            return this.allowDecimal
                ? parseFloat(val.replace(/[^0-9.]/, ""))
                : parseInt(val.replace(/[^0-9.]/, ""));
        },
        blur(val) {
            this.$emit("blur", val);
        },
        input(val) {
            this.$emit("input", this.removeFormat(val));
        },
    },
};
</script>
